import { Component, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
@Component({
  selector: 'app-vrsk-formly-flex-layout',
  templateUrl: './vrsk-formly-flex-layout.component.html',
  styleUrls: ['./vrsk-formly-flex-layout.component.scss']
})
export class VrskFormlyFlexLayoutComponent extends  FieldType<FieldTypeConfig> implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
